export default __webpack_public_path__ + "static/media/8.4264b8b4.jpg";